import { IObservable } from '~/rage/utils';
import { IRadialMenuItem, RadialMenuIcon } from '~/shared';

export function paginateMenuItems(items: IRadialMenuItem[]): IRadialMenuItem[] {
	const MAX_ITEMS_PER_PAGE = 8;

	function paginateRecursive(
		items: IRadialMenuItem[],
		isNested: boolean = false,
	): IRadialMenuItem[] {
		const maxItems = isNested ? MAX_ITEMS_PER_PAGE - 1 : MAX_ITEMS_PER_PAGE;

		if (items.length <= maxItems) {
			return items.map((item) => ({
				...item,
				nestedItems: item.nestedItems
					? paginateRecursive(item.nestedItems, true)
					: null,
			}));
		}

		let availableSlots: number;
		if (isNested) {
			availableSlots = MAX_ITEMS_PER_PAGE - 2;
		} else {
			availableSlots = MAX_ITEMS_PER_PAGE - 1;
		}

		const firstPageItems = items.slice(0, availableSlots);
		const remainingItems = items.slice(availableSlots);

		const pageItems = [
			...firstPageItems.map((item) => ({
				...item,
				nestedItems: item.nestedItems
					? paginateRecursive(item.nestedItems, true)
					: null,
			})),
			{
				action: 'next_page',
				icon: RadialMenuIcon.Next,
				text: 'Далее',
				subText: '',
				nestedItems: paginateRecursive(remainingItems, true),
			},
		];

		if (!isNested && pageItems.length >= 2) {
			const lastIndex = pageItems.length - 1;
			[pageItems[lastIndex], pageItems[lastIndex - 1]] = [
				pageItems[lastIndex - 1],
				pageItems[lastIndex],
			];
		}

		return pageItems;
	}

	return paginateRecursive(items);
}

export interface IRadialMenuService {
	getItems(): IObservable<IRadialMenuItem[]>;
	getBottomCaption(): IObservable<string>;
	selectItem(action: string): Promise<void>;
	exit(): Promise<void>;
}
